var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',{class:_vm.className,attrs:{"small":""},on:{"click":function($event){$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}},[_vm._v(" mdi-magnify ")])
}
var staticRenderFns = []

export { render, staticRenderFns }